var React = require('react');

function GlassWhiskey (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M119.53 415.15L89.52 224h333.15l-29.81 191.22-.07.43v.31H119.73l-.06-.4z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M442.63 96l-49.77 319.22-.07.43v.31H119.73l-.06-.4-.07-.44L69.42 96h373.21M480 32H32A32 32 0 0 0 .32 68.51l56 356.58A64 64 0 0 0 119.71 480h273a64.07 64.07 0 0 0 63.4-54.91l55.57-356.58A32 32 0 0 0 480 32z","className":"fa-primary","key":2})]);
}

GlassWhiskey.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = GlassWhiskey;

GlassWhiskey.default = GlassWhiskey;
